/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyDuration,
    JsonCompanyDurationFromJSON,
    JsonCompanyDurationFromJSONTyped,
    JsonCompanyDurationToJSON,
} from './JsonCompanyDuration';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyDuration
 */
export interface ApiResultOfJsonCompanyDuration {
    /**
     * 
     * @type {JsonCompanyDuration}
     * @memberof ApiResultOfJsonCompanyDuration
     */
    data?: JsonCompanyDuration;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDuration
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyDuration
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDuration
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDuration
     */
    result?: ApiResultOfJsonCompanyDurationResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyDurationResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyDurationFromJSON(json: any): ApiResultOfJsonCompanyDuration {
    return ApiResultOfJsonCompanyDurationFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyDurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyDuration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyDurationFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyDurationToJSON(value?: ApiResultOfJsonCompanyDuration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyDurationToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

